import React from 'react';
import { string, bool, shape, oneOf } from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components';
import './GalleryImage.scss';

export const MODE = {
    DEFAULT: 'default',
    VISUAL: 'visual',
};

export default function GalleryImage({
    className,
    src,
    lazyload,
    cdn,
    mode,
    ...otherProps
}) {
    const rootClassnames = classnames(
        'gallery-image',
        {
            'gallery-image--default': !mode || mode === MODE.DEFAULT,
            'gallery-image--visual': mode === MODE.VISUAL,
        },
        className,
    );

    return (
        <div className={rootClassnames}>
            <Image
                className="gallery-image__image"
                src={src}
                lazyload={lazyload}
                cdn={cdn}
                {...otherProps}
            />
        </div>
    );
}

GalleryImage.propTypes = {
    className: string,
    src: string,
    lazyload: bool,
    cdn: shape({
        CDN: string,
        CDN_IMAGE: string,
    }).isRequired,
    mode: oneOf([MODE.DEFAULT, MODE.VISUAL]),
};

GalleryImage.defaultProps = {
    className: null,
    src: null,
    lazyload: false,
    mode: MODE.DEFAULT,
};
